import React, {useState, useEffect} from "react";
import "../styles/ChooseProfile.css";
import { useNavigate} from 'react-router-dom';
import * as accessService from '../_services/accessService';
import Loader from '../components/Loader';

import { useUser } from "../context/UserContext";
import { toast } from "react-hot-toast";
import { toBoolean } from "../_utils/to.boolean";

const getRandomColor = () => {
  const colors = [
    "#6a11cb", "#2575fc", "#ee0979", "#ff6a00", "#56ab2f", "#8360c3"
  ];
  return colors[Math.floor(Math.random() * colors.length)];
};

export default function ChooseProfile() {
  const navigate = useNavigate();
  const { user } = useUser();
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null)
  const [alert, setAlert] = useState({ show: false, message: "", type: "info" });
  const [profiles, setProfiles] = useState([]);

  const handleFetch = async () => {
    setLoading(true);
    try {
      const getProfiles = await accessService.getProfiles();
      setProfiles(getProfiles.data || []);
    } catch (error) {
      toast.error(error.message || `Something went wrong. Please try again.`);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if(!user) {
      navigate("/login")
    }
    handleFetch();
  }, [user])

  const handleView = async (profile, target) => {
    navigate(`/business/?tenantId=${profile.tenantId}&target=${target}`, {state: {tenant:profile}});
  }


  const handleAccess = async (profile) => {
    setSelected(profile);
    setLoading(true);

    try {
      const accessId = profile.accessId;
      const getProfiles = await accessService.getAccess(accessId);
      const data = getProfiles.data.profile;
      const accessToken = getProfiles.data.accessToken;

      toast.success(getProfiles.message || `Profile access verified.`);

      window.location.href = `${data.appUrl}/verify/${accessToken}`;
    } catch (error) {
      toast.error(error.message || `Something went wrong. Please try again.`);
    } finally {
      setLoading(false);
    }
  };

  const active = (subscriptions) => {
    if(!subscriptions.length) return null;
    try {
      const sub =  subscriptions.find(sub => sub.isActive === 1);
      
      return sub;
    } catch (error) {
      return null
    }
  };
    
  return (
    <div className="profiles-page">
      <Loader show={loading} message="Processing, please wait..." />

      {/* Animated Background Blobs */}
      <div className="bg-blobs">
        <div className="blob blob1"></div>
        <div className="blob blob2"></div>
        <div className="blob blob3"></div>
      </div>
      {/* Hero / Intro */}
      <section className="profiles-hero">
        <h1>Choose Your Profile</h1>
      </section>

      {/* Profiles */}
      <section className="profiles-section">
        {profiles.length > 0 ? (
          <div className="profiles-grid">
            {profiles.map((profile) => (
              <div
                key={profile.accessId}
                className="profile-card"
                style={{ background: getRandomColor() }}
              >
                <h3>{profile.businessName}</h3>
                <p>{profile.accessLevel}</p>

                {
                  profile.businessStatus === "ACTIVE" && profile.status === "ACTIVE" 
                  ?
                    <>
                    {
                      active(profile.subscriptions)
                      ? 
                        <>
                          <h3>
                            {profile.subscriptions[0].productName} 
                            {" "}
                            ({profile.subscriptions[0].planName})
                          </h3>
                          
                        </>
                      :
                        <p className="">
                          There is no active subscription for this profile
                        </p>
                    }
                    </> 
                  :
                    <p>
                      Access to this profile is restricted at the moment. <br/>
                      Insure your institution has granted you access and the business profile is active.
                    </p>
                  
                }
                
                {
                  profile.accessLevel === "ADMIN" ?
                    <>
                      <button
                        className="access-btn m-1"
                        onClick={() => handleView(profile, "details")}
                      >
                        Company
                      </button>
                      <button
                        className="access-btn m-1"
                        onClick={() => handleView(profile, "subscriptions")}
                      >
                        Subscriptions
                      </button>
                      <button
                        className="access-btn m-1"
                        onClick={() => handleView(profile, "invoices")}
                      >
                        Invoices
                      </button>
                    </>
                    :<></>
                }
                {
                   active(profile.subscriptions) && profile.businessStatus === "ACTIVE" && profile.status === "ACTIVE"
                  ? 
                    <button
                      type="button"
                      className="access-btn btn m-1"
                      onClick={() => handleAccess(profile, "access")}
                    >
                      Enter
                    </button> 
                  : <></>
                }
              </div>
            ))}
          </div>
        ) : (
          <div className="empty-profiles">
            <div className="empty-icon">🏢</div>
            <h2>No Profiles Found</h2>
            <p>
              You don't have access to any business profiles yet or you may have been 
              logged out. Try logging in or register a new business to
              get started, or ask an administrator to grant you access to an existing
              business.
            </p>
          </div>
        )}

        {/* CTA - Always Visible */}
        <div className="register-business-cta">
          <h3>Need a new business?</h3>
          <p>
            Register your business and start using the Magyne platform in just a few
            minutes.
          </p>

          <button
            className="register-business-btn"
            onClick={() => navigate("/solutions")}
          >
            Register New Business
          </button>
        </div>
      </section>
      {/* Floating Shapes */}
      <div className="floating-shape shape1"></div>
      <div className="floating-shape shape2"></div>
      <div className="floating-shape shape3"></div>
    </div>
  );
}
